const LOCALHOST_HOSTS = new Set(['localhost', '127.0.0.1', '[::1]']);

const normalizeBaseUrl = (url: string): string => {
  return url.replace(/\/+$/, '');
};

const isLocalhostRuntime = (): boolean => {
  if (typeof window === 'undefined') return false;
  return LOCALHOST_HOSTS.has(window.location.hostname);
};

const isLocalhostUrl = (url: string): boolean => {
  try {
    return LOCALHOST_HOSTS.has(new URL(url).hostname);
  } catch {
    return /^https?:\/\/(localhost|127\.0\.0\.1|\[::1\])(?::\d+)?$/i.test(url);
  }
};

const isEmulatorFlagEnabled = (): boolean => {
  return (
    process.env.NEXT_PUBLIC_USE_FIREBASE_EMULATOR === 'true' ||
    process.env.NEXT_PUBLIC_FIREBASE_EMULATOR === 'true'
  );
};

const getProjectId = (): string => {
  // デフォルトは prod (prd-nomiss-web) - stg の場合は環境変数で明示的に指定
  return process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID || 'prd-nomiss-web';
};

const getDefaultProdBaseUrl = (): string => {
  return `https://asia-northeast2-${getProjectId()}.cloudfunctions.net`;
};

const getDefaultEmulatorBaseUrl = (): string => {
  return `http://127.0.0.1:5001/${getProjectId()}/asia-northeast2`;
};

export const isEmulatorRuntime = (): boolean => {
  return isEmulatorFlagEnabled() && isLocalhostRuntime();
};

export const getFunctionsBaseUrl = (): string => {
  const configuredBaseUrl =
    process.env.NEXT_PUBLIC_FUNCTIONS_BASE || process.env.NEXT_PUBLIC_FIREBASE_FUNCTIONS_URL || '';

  if (isEmulatorRuntime()) {
    if (configuredBaseUrl && isLocalhostUrl(configuredBaseUrl)) {
      return normalizeBaseUrl(configuredBaseUrl);
    }
    return getDefaultEmulatorBaseUrl();
  }

  if (configuredBaseUrl && !isLocalhostUrl(configuredBaseUrl)) {
    return normalizeBaseUrl(configuredBaseUrl);
  }

  return getDefaultProdBaseUrl();
};
